import { render, staticRenderFns } from "./ProjectOverviewCarrousel.vue?vue&type=template&id=4b0d9736&scoped=true&"
import script from "./ProjectOverviewCarrousel.vue?vue&type=script&lang=js&"
export * from "./ProjectOverviewCarrousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d9736",
  null
  
)

export default component.exports